import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setListAttendeesPage = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<number>((state, action) => {
    state.listAttendees.page = action.payload;
  });
